import { gql } from "@apollo/client";

export const BUS_STOPS = gql`
  query ($ids: [Int], $lang: String, $busStopName: String) {
    busStops(ids: $ids, lang: $lang, busStopName: $busStopName) {
      BusStopId
      BusStopName
      BusStopCode
      BusStopExternalCode
      CountyName
      CountryName
      HasPriority
      IsAirportBusStop
      IsWheelchairAccessible
      Address {
        Street
        ZipCode
        CityName
      }
      Coordinates {
        Latitude
        Longitude
      }
      # Comment
      # Platforms {
      #   Name
      #   Coordinates {
      #     Latitude
      #     Longitude
      #   }
      # }
    }
  }
`;
